module.exports = __webpack_public_path__ + "static/DEFENCE_EXERCISE-496355f778d034469c838700439d93be.jpeg";